import { Trans } from 'react-i18next';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { CompetitionEndingSoonNotificationData } from './interfaces';

const isCompetitionEndingSoonPayload = (
  payload: unknown
): payload is CompetitionEndingSoonNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  const milestone = (payload as CompetitionEndingSoonNotificationData).milestone;

  return (
    'competitionName' in payload &&
    typeof payload.competitionName === 'string' &&
    (milestone === 'last_month' ||
      milestone === 'two_weeks' ||
      milestone === 'last_week')
  );
};

export const competitionEndingSoonPresenter: NotificationPresenter<CompetitionEndingSoonNotificationData> =
  {
    type: 'competition-ending-soon',
    icon: EmojiEventsIcon,
    badgeIcon: DateRangeIcon,
    isPayload: isCompetitionEndingSoonPayload,
    label: (payload, t) =>
      t(`notifications:types.competition-ending-soon.${payload.milestone}`, {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey={`notifications:menu.competition-ending-soon.${payload.milestone}`}
        values={{
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return ROUTES.portal.competitions.details(payload.competitionSlug);
    },
  };
